fx.ns("shared.renderers", class AlbumRenderer extends fx.Component {
    
	constructor(data)
	{
        super(data);
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.impacts("selected") )
            this.toggleClass("selected", this.data.selected);
    }

    onChildUpdated(action)
    {
        if (action.type == "update" && action.impacts("selected"))
            this._updateNumPhotos();
    }

    onReady()
    {
        this.attr("data-id",  this.data.id);
        this.toggleClass("selected", this.data.selected);

        this._updateNumPhotos();
    }

    create()
    {
        super.create();
        let box = new fx.components.Box("album");

        box.addChild( new fx.components.Image( {className : "image", url : this.data.cover_url} ), { top : 2, left : "center", width : "auto", height : "auto"});
        box.addChild( new fx.components.Text({ className : "text", text : (this.data.count > 1 ? fx.text("$ photos", this.data.count) : fx.text("$ photo", this.data.count)) }), { bottom : 15, left : 0, width : "100%", height : "30"});

        this.numPhotos = new fx.components.Text({className : "numphotos"});
        this.numPhotos.visibleAtStart = false;
        box.addChild( this.numPhotos, { top : 5, left : 15, width : "auto", height : "auto"} );
        this.addChild(box, { top : 0, left : 0, width : "100%", height : "100%"});
    }

    _updateNumPhotos()
    {
        this.numPhotos.text = this.data.selectedPhotos.length;
        this.numPhotos.toggle(this.data.selectedPhotos.length > 0);
    }

    /*render()
    {
        let html = "<div class='album'>";
        html += "<div class='numphotos'></div>"
        html += "<img class='image' src='" + this.data.cover_url + "'></img>";
        html += "<div class='text'>" + (this.data.count > 1 ? fx.text("$ photos", this.data.count) : fx.text("$ photo", this.data.count)) + "</div>";
        html += "</div>";
        return html;
    }*/

}); 